import { Model } from "pinia-orm";

export default class Document extends Model {
  static name = "DocumentType";
  static entity = "documentTypes";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
    };
  }
}
